/* istanbul ignore file */
import { FormSection, FormRow } from 'framework/ui/layout';
import { InputList, TextArea, TextInput } from 'framework/form';
import { AvailableBudgetsDropdown, BudgetInput } from 'domain/shared/budget';

const BudgetReallocationForm = () => {
  return (
    <FormSection title="Budget Reallocation information">
      <FormRow>
        <BudgetInput
          filter={{ notArchived: true, budgetOwner: true, hasActivePeriod: true }}
          source="budgetFromId"
          label="Source dudget"
          searchString="name"
        />
        <AvailableBudgetsDropdown
          filter={{ notArchived: true }}
          placeholder="Choose budget"
          budgetFromSource="budgetFromId"
          source="budgetToId"
          label="Destination dudget"
        />
      </FormRow>
      <FormRow>
        <InputList
          source="ticketIds"
          label="Redmine ticket Id"
          maxFields={1000}
          addText="Add Redmine ticket id"
          inputTemplate={TextInput}
        />
      </FormRow>
      <FormRow>
        <TextArea source="reason" />
      </FormRow>
    </FormSection>
  );
};

export default BudgetReallocationForm;
